import { UtilityProgram } from '@/types/utilityProgram'
import UtilityConnectLinkRow from '../UtilityConnectLinkRow/utility-connect-link-row'
import { createUtilityLink } from './ExternalUtilityConnectionLinks.utils'
import { Utility } from '@/types'
type Props = {
  utilityProgram: UtilityProgram
  utilityRefId?: string
  utilityNameFilter?: string
  onButtonClick?: (utility: Utility) => Promise<void>
}
export default function ExternalUtilityConnectionLinks({
  utilityProgram,
  utilityRefId,
  onButtonClick,
}: Props) {
  const connectConfigs = utilityProgram.utilities.map((utility) => ({
    utility,
    url: createUtilityLink(
      utilityProgram.utilities_api_provider_urls[utility.id],
      utilityRefId,
    ),
  }))
  return (
    <section className="flex flex-col gap-2 [&>:not(:last-child)]:border-b [&>*]:border-gray-200 [&>*]:border-solid [&>*]:p-2">
      {connectConfigs.map((config) => (
        <UtilityConnectLinkRow
          key={config.utility.name}
          {...config}
          onClick={onButtonClick}
        />
      ))}
    </section>
  )
}
